/*
 * What a Profile field may hold, kept free of any import so the web app checks an edit by the same
 * rules `access` does.
 */

/** The most characters each Profile field a Member edits may hold. */
export const profileFieldLimits = {
  firstName: 80,
  lastName: 80,
  pronouns: 40,
  jobTitle: 100,
  location: 100,
  timeZone: 64,
  about: 1_000,
} as const

/** Whether a time zone is one IANA's database names, as this runtime knows it. */
export function isTimeZone(zone: string) {
  try {
    new Intl.DateTimeFormat("en", { timeZone: zone })
    return true
  } catch {
    return false
  }
}
